import { render, staticRenderFns } from "./MetaboliteEdit.vue?vue&type=template&id=02759ef8&scoped=true&"
import script from "./MetaboliteEdit.vue?vue&type=script&lang=js&"
export * from "./MetaboliteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02759ef8",
  null
  
)

export default component.exports